import { render } from "./LogConsultaAfiliados.vue?vue&type=template&id=36ac8efd"
import script from "./LogConsultaAfiliados.vue?vue&type=script&lang=js"
export * from "./LogConsultaAfiliados.vue?vue&type=script&lang=js"

import "./LogConsultaAfiliados.vue?vue&type=style&index=0&id=36ac8efd&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__